import { IRawFormConfig, IFormConfig } from 'js/components/common/Form/types';

export const parseForms = (forms: IRawFormConfig[] = []): IFormConfig[] =>
    forms.map(form => ({
        ...form.form,
        id: form.id,
        name: form.name,
        formFields: form.form.formFields || form.form.formElements || [],
        formRules: form.form.formRules || []
    }));
